import { GlobalVariables } from '../core/globalvar.service'

export function globalvar_provider(globalvar : GlobalVariables) {
    return (): Promise<any> => {
        return globalvar.init()
    }
}